import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _get from "@babel/runtime/helpers/esm/get";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
var _excluded = ["infoId", "uid"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.number.constructor.js";
import WaitJsLoaded, { loadJS } from "../utils/WaitJsLoaded";
import { getCookie } from "../utils/cookies";
import messager from "../events/messager";
import { searchM } from "../utils/urls";
import { getDetailUrl, urlFormatter, getPPU, getDomain, getUrlParams, isIphoneX, domainReplacement } from "../utils/utils";
import { platform } from "../platform/getCurrentPlatform";
import { ajax, request } from "../utils/ajax";
import { lego } from "../utils/lego";
import compareVersion from "../utils/compareVersion";
var QQ_MAP_KEY = "ATQBZ-DRPRJ-PCMFD-FEOUW-OV3NK-J2BEG";
var API_DOMAIN = /58\.com/.test(location.href) ? "zhuan.58.com" : "app.zhuanzhuan.com";

var counter = function () {
  var c = 0;
  return function () {
    return c++;
  };
}();

var BaseAdapter = /*#__PURE__*/function (_WaitJsLoaded) {
  _inherits(BaseAdapter, _WaitJsLoaded);

  var _super = _createSuper(BaseAdapter);

  function BaseAdapter() {
    _classCallCheck(this, BaseAdapter);

    return _super.apply(this, arguments);
  }

  _createClass(BaseAdapter, [{
    key: "_invoke",
    value: function _invoke(key, argv) {
      var _this = this;

      messager.$emit.apply(messager, [key].concat(_toConsumableArray(argv)));

      this._invokeCB(function () {
        if (_this[key]) {
          _get(_getPrototypeOf(BaseAdapter.prototype), "_invoke", _this).call(_this, key, argv);
        } else if (!_this.__sdk || !_this.__sdk[key]) {
          // 新版sdk中使用run运行方法
          if (platform.name == "zz" || platform.name == "zlj" && platform.isNewWebview) {
            var _this$__sdk;

            (_this$__sdk = _this.__sdk).run.apply(_this$__sdk, [key].concat(_toConsumableArray(argv)));
          } else {
            console.warn("\u8BE5\u7AEF\u672A\u5B9E\u73B0".concat(key, "\u65B9\u6CD5\uFF0C\u8BF7\u786E\u8BA4"));
          }
        } else {
          _this.__sdk[key].apply(_this.__sdk, argv);
        }
      });
    }
  }, {
    key: "asyncIn",
    value: function asyncIn(keyword) {
      var cbsucss = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
      var cbfail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      (native["in"](keyword) ? cbsucss : cbfail)();
    }
  }, {
    key: "getFormatPPU",
    value: function getFormatPPU() {
      return getPPU() || "";
    }
  }, {
    key: "getUid",
    value: function getUid() {
      var uid = getPPU().UID || getCookie("uid");
      return /\d{6,24}/.test(uid) ? uid : "";
    }
  }, {
    key: "skipToSearchResult",
    value: function skipToSearchResult(obj) {
      var keyWord = obj.keyWord,
          title = obj.title;
      var history = localStorage.getItem("searchHistory") || "";
      var encodeKeyWord = encodeURIComponent(keyWord);
      history = [encodeKeyWord].concat(_toConsumableArray(history.split(",").filter(function (v) {
        return v;
      }))).reduce(function (arr, key) {
        if (arr.indexOf(key) < 0) arr.push(key);
        return arr;
      }, []).slice(0, 10).join(",");
      localStorage.setItem("searchHistory", history);
      this.skipToUrl({
        targetUrl: searchM(keyWord),
        newPageTitle: title
      });
    }
  }, {
    key: "isLoginAsync",
    value: function isLoginAsync(_ref) {
      var source = _ref.source,
          callback = _ref.callback;

      // 没有传source的情况，直接走同步的isLogin
      if (typeof source === "undefined") {
        callback && callback(this.isLogin());
        return;
      }

      var cbName = "isLoginAsync".concat(counter());

      window[cbName] = function (data) {
        var respCode = data.respCode,
            respData = data.respData;
        callback && callback(+respCode === 0 ? respData.result === "true" : false);
      };

      loadJS("https://".concat(API_DOMAIN, "/zz/transfer/hasauthorized?source=").concat(source, "&callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "isLogin",
    value: function isLogin() {
      // const isZLJNew = /zhaoliangji-v2/ig.test(navigator.userAgent)
      // if (isZLJNew) {
      //   // 找靓机新的webview里面，通过sdk的方法判断是否登录
      //   return false;
      // }
      console.log("如果是找靓机App，也可以使用checkLogin来判断是否登录");

      if (platform.name === "app58") {
        return !!(getCookie("PPU") && getCookie("ZZU"));
      } // 小程序中判断cookies是否含有PPU并且是否过期


      if (platform.name === "miniprogram") {
        if (!getCookie("PPU") || getCookie("PPU").replace(/"/g, "") && !this.getFormatPPU().ET || getCookie("PPU").replace(/"/g, "") && this.getFormatPPU().ET && !window.isNaN(parseInt(this.getFormatPPU().ET)) && parseInt(this.getFormatPPU().ET) < new Date().getTime()) {
          // 如果过期从url读取ppu
          var params = getUrlParams();
          var ppu = decodeURIComponent(params.PPU || "");

          if (!!ppu && !/^['|"]/.test(ppu)) {
            ppu = "\"".concat(ppu, "\"");
            setCookieOrigin("PPU", ppu);
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      }

      return !!getCookie("PPU").replace(/"/g, "") && this.getFormatPPU().ET && !window.isNaN(parseInt(this.getFormatPPU().ET)) && parseInt(this.getFormatPPU().ET) >= new Date().getTime();
    }
  }, {
    key: "bindPhone",
    value: function bindPhone() {
      var targetUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var domain = getDomain(targetUrl);
      var url = domain + "/common/loginsms/index.html?updateMobile=true&forceBind=true&callbackUrl=" + encodeURIComponent(targetUrl) + "#/login";

      if (replace) {
        location.replace(url);
      } else {
        location.href = url;
      }
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(callback) {
      var cbName = "getUserInfoCb".concat(counter());

      window[cbName] = function (data) {
        if (typeof callback != "function") {
          callback = callback.success;
        }

        callback && callback(data);
      };

      loadJS("https://".concat(API_DOMAIN, "/zzopen/userapi/myinfo?callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "isBindPhone",
    value: function isBindPhone(callback) {
      var cbName = "getIsBindPhoneCb".concat(counter());

      window[cbName] = function (data) {
        var respCode = data.respCode,
            respData = data.respData;
        callback && callback(+respCode === 0 ? respData.isBindMobile : false);
      };

      loadJS("https://".concat(API_DOMAIN, "/zz/transfer/isUserBindMobile?callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail(obj) {
      var _this2 = this;

      var infoId = obj.infoId,
          _obj$metric = obj.metric,
          metric = _obj$metric === void 0 ? "" : _obj$metric,
          isTrade = obj.isTrade,
          _obj$from = obj.from,
          from = _obj$from === void 0 ? "" : _obj$from,
          _obj$extra = obj.extra,
          extra = _obj$extra === void 0 ? {} : _obj$extra;
      var cbName = "getCoodsDetailDataCb".concat(counter());
      obj.$customUrl = "".concat(getDomain(), "/platform/zzmshare/index.html?isTrade=").concat(isTrade ? 1 : 0, "&metric=").concat(metric, "&zzfrom=").concat(metric, "#/detail/").concat(infoId);
      var defaultUrl = getDetailUrl(obj);

      window[cbName] = function (data) {
        var respCode = data.respCode,
            respData = data.respData;

        if (+respCode === 0) {
          defaultUrl = respData.webUrl || defaultUrl;
        }

        _this2.agentSkipToDetail(obj, function () {
          _this2.skipToUrl({
            targetUrl: defaultUrl,
            extra: extra
          });
        });
      };

      loadJS("https://app.zhuanzhuan.com/zz/transfer/getgoodsdetaildataexclusive?infoId=".concat(infoId, "&from=").concat(from, "&callback=").concat(cbName, "&metric=").concat(metric), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "agentSkipToDetail",
    value: function agentSkipToDetail(obj, cb) {
      var metric = obj.metric,
          businessTicket = obj.businessTicket;

      if (businessTicket && businessTicket.adTicket) {
        var ticketData = _objectSpread({
          metric: metric
        }, businessTicket);

        return this.getBusinessTicket(ticketData, function () {
          cb();
        });
      }

      return cb();
    }
  }, {
    key: "enterProfile",
    value: function enterProfile(obj) {
      var userId = obj.userId;
      var targetUrl = "".concat(getDomain(), "/platform/zzmshare/index.html#/personal/").concat(userId);
      return this.skipToUrl({
        targetUrl: targetUrl
      });
    }
  }, {
    key: "getMapLocation",
    value: function getMapLocation() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      // 兼容旧版 只传入callback
      if (typeof obj === "function") {
        callback = obj;
      }

      var v = getCookie("v");

      if (!obj.ignoreApp && native["in"]("zz") && compareVersion(v, "6.4") > 0) {
        var cb = function cb(res) {
          var _ref2 = res.villageInfo || {},
              lat = _ref2.lat,
              lng = _ref2.lng,
              address = _ref2.address,
              villageName = _ref2.villageName,
              businessName = _ref2.businessName;

          var o = {
            module: "locationPicker",
            latlng: {
              lat: lat,
              lng: lng
            },
            poiaddress: address,
            poiname: villageName,
            cityname: businessName
          };
          typeof callback === "function" && callback(o);
        };

        var _lon = getCookie("lon");

        var _lat = getCookie("lat");

        if (parseFloat(_lon) === 0 && parseFloat(_lat) === 0) {
          this.ZZAPP.toast({
            msg: "抱歉，当前无法获取地理位置，请设置允许转转使用定位功能"
          });
          return;
        }

        this.ZZAPP.getMapLocation(Object.assign({}, {
          lon: _lon,
          lat: _lat
        }), cb);
        return;
      } // 腾讯地图文档 https://lbs.qq.com/tool/component-picker.html


      var mapPage = document.getElementById("mapPage");
      var lon = obj.lon,
          lat = obj.lat,
          coordtype = obj.coordtype; // coord用英文逗号分隔，纬度(latitude)在前，经度(longitude)在后  coord=40.022964,116.319723

      var coord = "";

      if (lon && lat) {
        coord = "&coord=".concat(lat, ",").concat(lon, "&coordtype=").concat(coordtype || 5);
      }

      var mapUrl = "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=".concat(QQ_MAP_KEY, "&referer=zzapp") + coord;

      var creatIframe = function creatIframe() {
        var iframe = document.createElement("iframe"); // 设置iframe的样式

        iframe.style.width = "100%";
        iframe.style.height = "100vh";
        iframe.style.boxSizing = "border-box";
        iframe.style.position = "fixed";
        iframe.style.top = "0";
        iframe.style.left = "0";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.border = "none";
        iframe.style.zIndex = "10000";

        if (getUrlParams().needHideHead !== "0" && native["in"]("zzseller")) {
          // 如果是在app中并且url中存在needHideHead=2，那么就当做全面屏处理，iPhone X预留44px，其余手机预留20px
          var padding = 34;

          if (isIphoneX()) {
            padding = 44;
          }

          iframe.style.paddingTop = "".concat(padding, "px");
          iframe.style.backgroundColor = "#fff";
        }

        iframe.id = "mapPage";
        iframe.frameborder = 0;
        iframe.src = mapUrl;
        document.body.appendChild(iframe);
      };

      if (!mapPage) creatIframe();else {
        mapPage.style.display = "block";
      }

      var listenserFun = function listenserFun(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;

        if (loc && loc.module === "locationPicker" && loc.poiaddress) {
          // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          try {
            var map = document.getElementById("mapPage");
            setTimeout(function () {
              map.style.display = "none";
              window.removeEventListener("message", listenserFun);
              typeof callback === "function" && callback(loc);
            }, 300);
          } catch (error) {}
        }
      };

      window.addEventListener("message", listenserFun, false);
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(params, callback) {
      var href = "https://apis.map.qq.com/tools/poimarker?type=0&marker=coord:".concat(params.lat || 0, ",").concat(params.lon || 0, ";title:").concat(params.name || "", ";addr:").concat(params.address || "", "&init_view=").concat(params.scale || 28, "&key=").concat(QQ_MAP_KEY, "&referer=zzapp");

      if (/58ZhuanZhuan/g.test(navigator.userAgent) && params.needOpenNewpage) {
        var _params$needClose = params.needClose,
            needClose = _params$needClose === void 0 ? "0" : _params$needClose,
            _params$newPageTitle = params.newPageTitle,
            newPageTitle = _params$newPageTitle === void 0 ? "转转" : _params$newPageTitle;
        this.ZZAPP.enterPage(Object.assign({}, {
          targetUrl: href,
          needClose: needClose,
          newPageTitle: newPageTitle
        }), callback);
      } else {
        location.href = href;
      }
    }
  }, {
    key: "getBusinessTicket",
    value: function getBusinessTicket(obj, cb) {
      var legoParams = Object.assign({}, {
        token: getCookie("tk"),
        brand: getCookie("brand"),
        version: getCookie("v"),
        lon: getCookie("lon"),
        lat: getCookie("lat"),
        ua: window.navigator.userAgent
      }, obj);
      lego("AD_YOUPINLIST", "AD_CLICK_ALL", _objectSpread({
        status: 0
      }, legoParams));
      ajax({
        url: "https://jump.zhuanzhuan.com/api/click",
        params: {
          metric: obj.metric,
          adTicket: obj.adTicket
        },
        method: "GET",
        timeout: 1000,
        header: {},
        timeoutCb: function timeoutCb() {
          lego("AD_YOUPINLIST", "AD_CLICK", _objectSpread({
            status: 3
          }, legoParams));
          setTimeout(function () {
            cb();
          }, 100);
        },
        successCb: function successCb() {
          lego("AD_YOUPINLIST", "AD_CLICK", _objectSpread({
            status: 1
          }, legoParams));
          setTimeout(function () {
            cb();
          }, 100);
        },
        errorCb: function errorCb() {
          lego("AD_YOUPINLIST", "AD_CLICK", _objectSpread({
            status: 2
          }, legoParams));
          setTimeout(function () {
            cb();
          }, 100);
        }
      });
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = obj.url,
          addressId = obj.addressId;
      var href = "".concat(getDomain(), "/trade/user-address/index.html?url=").concat(encodeURIComponent(url || window.location.href), "&addressId=").concat(addressId || 0, "#/myAddress");
      window.location.href = href;
    }
  }, {
    key: "close",
    value: function close() {
      window.close();
    } // 推荐使用交易团队提供的trade-core库来实现跳转下单等功能

  }, {
    key: "skipToOrder",
    value: function skipToOrder(obj) {
      var orderUrl = obj.orderUrl,
          metric = obj.metric,
          infoId = obj.infoId;

      if (orderUrl) {
        window.location.href = urlFormatter(orderUrl);
        return;
      }

      window.location.href = "".concat(getDomain(), "/trade/create-order/index.html?metric=").concat(metric, "&infoId=").concat(infoId, "#/home");
    } // 推荐使用交易团队提供的trade-core库来实现跳转订单详情等功能

  }, {
    key: "enterOrderDetail",
    value: function enterOrderDetail(obj) {
      var orderId = obj.orderId,
          metric = obj.metric;
      window.location.href = "".concat(getDomain(), "/trade/order-detail/home.html?orderId=").concat(orderId, "&metric=").concat(metric);
    }
  }, {
    key: "enterChat",
    value: function enterChat(obj) {
      var infoId = obj.infoId,
          uid = obj.uid,
          rest = _objectWithoutProperties(obj, _excluded);

      var restList = [];
      Object.keys(rest).forEach(function (key) {
        restList.push(encodeURIComponent(key + "=" + rest[key]));
      });
      var restParam = "";

      if (restList.length > 0) {
        restParam = "&" + restList.join("&");
      }

      window.location.href = "//chat.zhuanzhuan.com/m/?infoId=".concat(infoId, "&userId=").concat(uid).concat(restParam);
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      if (_typeof(callback) === "object") {
        callback = callback.callback;
      }

      document.addEventListener("visibilitychange", function (e) {
        if (document.visibilityState === "visible") {
          callback && callback(e);
        }
      });
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(callback) {
      var cbName = "getCoordinate".concat(counter());

      window[cbName] = function (res) {
        if (res.status === 0) {
          var position = res.result.location;
          callback({
            code: "0",
            lon: String(position.lng),
            lat: String(position.lat),
            result: res.result
          });
        } else {
          callback({
            code: "-1"
          });
        }
      };

      loadJS("https://apis.map.qq.com/ws/location/v1/ip?key=".concat(QQ_MAP_KEY, "&output=jsonp&callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      }); // 该API腾讯地图已经废弃，有bug
      // loadJS('https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js', () => {
      //   const geolocation = new qq.maps.Geolocation(QQ_MAP_KEY, "zzapp");
      //   geolocation.getLocation((position) => {
      //     callback({
      //       code: "0",
      //       lon: position.lng,
      //       lat: position.lat
      //     });
      //   }, () => {
      //     callback({ code: '-1' });
      //   })
      // });
    }
  }, {
    key: "replaceDomain",
    value: function replaceDomain(originUrl) {
      return domainReplacement(originUrl);
    }
  }, {
    key: "goBack",
    value: function goBack(callback) {
      // 返回上一个页面，如果当前页面处于历史页面栈顶，则执行关闭页面方法
      // 通过referrer是否为空来判断页面是否处于历史堆栈顶层
      if (document.referrer === "") {
        this.close();
      } else {
        history.go(-1);
      } // 提供回调函数，用于回退失败时候执行部分逻辑


      callback && callback();
    }
    /**
     *  发送验证码
     *
     * @param {tel} tel 手机号 某些动作不需要手机号，登录态取UID 获取手机号
     * @param {channel} channel 'sms'（发送验证码过风控，有可能拉起图形验证码）'smssa'(直接发送)
     * @param {action} action   动作 200: 注册 201:登录 206:身份核验 205:换绑手机号 忘记密码：1003  207 5-M页验证码登录
     * @param {type} type  注册图形验证码的信息 2:uid获取图形验证码 3:token获取图形验证码 4:mobile获取图形验证码
     * @param {uuid} uuid	用户唯一标识, 根据type决定类型
     * @returns { code: 0, data: {} }   0 或者 -1  data 是返回的数据  -1 是提示信息
     * @memberof BaseAdapter
     */

  }, {
    key: "sendValidationCode",
    value: function () {
      var _sendValidationCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params, cb) {
        var _this3 = this;

        var res, _res;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(params.channel === "smssa")) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return this.sendCode(params);

              case 3:
                res = _context2.sent;
                cb(res);

              case 5:
                if (!(params.channel === "sms")) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 8;
                return this.sendCode(params);

              case 8:
                _res = _context2.sent;

                // 如果需要拉起
                if (_res && _res.data && _res.data.alertCode) {
                  this.registerSlider(params, /*#__PURE__*/function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res58) {
                      var resAuth;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(res58.code == 0)) {
                                _context.next = 7;
                                break;
                              }

                              _context.next = 3;
                              return _this3.sendCode(_objectSpread(_objectSpread({}, params), {}, {
                                channel: "smsslg",
                                codeid: res58.data.sessionId,
                                codetoken: res58.data.successToken
                              }));

                            case 3:
                              resAuth = _context.sent;
                              cb(resAuth);
                              _context.next = 8;
                              break;

                            case 7:
                              cb(res58);

                            case 8:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));

                    return function (_x3) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                } else {
                  cb(_res);
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function sendValidationCode(_x, _x2) {
        return _sendValidationCode.apply(this, arguments);
      }

      return sendValidationCode;
    }() // 发送验证码

  }, {
    key: "sendCode",
    value: function sendCode(params) {
      return new Promise(function (resolve) {
        request({
          url: "https://app.zhuanzhuan.com/zz/transfer/getvalidationcode",
          params: params
        }).then(function (res) {
          if (res.respCode == 0) {
            resolve({
              code: 0,
              data: res.respData
            });
          } else {
            resolve({
              code: -1,
              data: res.errMsg
            });
          }
        })["catch"](function () {
          resolve({
            code: -1,
            data: "验证码发送失败"
          });
        });
      });
    }
  }, {
    key: "getCookie",
    value: function getCookie(callback) {
      callback({
        code: "0",
        cookie: document.cookie
      });
    } // 拉起滑动验证码

  }, {
    key: "registerSlider",
    value: function registerSlider(params, callback) {
      loadJS("https://j1.58cdn.com.cn/resource/xxzl/captcha/js/isd_captcha.js?=".concat(new Date().setHours(0, 0, 0, 0)), function () {
        request({
          url: "https://app.zhuanzhuan.com/zz/transfer/registerslidernew",
          method: "post",
          params: {
            uuid: params.uuid || getCookie("tk"),
            scenetype: params.scenetype || 77,
            width: params.width || 280,
            type: params.type || 3,
            subOp: params.action
          }
        }).then(function (res) {
          var code = parseInt(res.respCode),
              data = res.respData;

          if (code === 0) {
            var captcha = window.ISDCaptcha({
              element: "ISDCaptcha",
              //验证码组件需要绑定的元素ID
              width: data.controlParams.width,
              //图片宽度,需从管理后台配置，调用注册接口是controlParams参数返回
              type: Number(data.level),
              //验证码类型; 调用注册接口时返回的level
              showType: params.showType || "win",
              //展现形式;win:弹出，trigger:触发,embed:嵌入
              sessionId: data.sessionId,
              // 调用注册接口时返回的sessionid
              targetElm: "loginBtn",
              // 如果为弹出式时,绑定为触发弹出的按钮ID
              winAutoShow: true,
              //弹出式时添加此属性会自动弹出	，,默认不自动弹出,点targetElm绑定的元素时弹出
              successCallback: function successCallback(value) {
                //验证码验证成功后的回调函数
                callback({
                  code: 0,
                  data: _objectSpread({
                    sessionId: data.sessionId
                  }, value)
                });
              },
              failCallback: function failCallback(data) {
                lego("SENTRY_ADATPER_SENDCODE", "SENTRY_ADATPER_SENDCODE_FAIL", data);
                callback({
                  code: -1,
                  data: "身份验证失败"
                });
              },
              errorCallback: function errorCallback(data) {
                lego("SENTRY_ADATPER_SENDCODE", "SENTRY_ADATPER_SENDCODE_ERROR", data);
                callback({
                  code: -2,
                  data: data
                });
              },
              closeCallback: function closeCallback(data) {
                callback({
                  code: -3,
                  data: data
                });
              }
            });
            captcha.init(); //初始化组件
          } else {
            callback({
              code: -1,
              data: res.errMsg || res.respMsg || "身份验证失败"
            });
          }
        })["catch"](function (err) {
          console.log("58sdk发送错误：", err);
          lego("SENTRY_ADATPER_SENDCODE", "SENTRY_ADATPER_SENDCODE_SDKERROR", err); // callback({ code: -1, data: "身份验证失败" });
        });
      });
    }
  }]);

  return BaseAdapter;
}(WaitJsLoaded);

export { BaseAdapter as default };